export default "__VITE_ASSET__BJCjIOcG__"